import React from "react";
import { Big as HighlightBig } from "./Big";
import { Small as Highlight } from "./Small";
export var View = function (_a) {
    var data = _a.data, className = _a.className, variant = _a.variant, listName = _a.listName, position = _a.position, playIcon = _a.playIcon;
    var trackingObject = function () {
        var _a;
        if (!data || data.kind === "Text")
            return undefined;
        return {
            list: listName,
            product: {
                id: data.uuid,
                name: (_a = data.title) !== null && _a !== void 0 ? _a : "",
                position: position,
                category: data.type,
            },
        };
    };
    switch (variant) {
        case "small":
            return (React.createElement(Highlight, { data: data, className: className, trackingObject: trackingObject(), playIcon: playIcon }));
        case "big":
            return (React.createElement(HighlightBig, { data: data, className: className, trackingObject: trackingObject(), playIcon: playIcon }));
    }
};
